import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

// firebase
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireStorageModule } from 'angularfire2/storage';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
// other modules
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgModule } from '@angular/core';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { ToastModule } from 'ng2-toastr';
import { ToastOptions } from 'ng2-toastr';
export class CustomOption extends ToastOptions{
    animate = 'flyLeft';
    newestOnTop = false;
    positionClass: 'toast-bottom-left'
  }
// bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Providers
import { AuthProvider, AuthGuard } from './providers/auth';
import { Utils } from './providers/utils';
import { NotificacionesProvider } from './providers/notificaciones';
import { PlanesProvider } from './providers/planes';
import { User } from './providers/user';
// partials and commons
import { AppNavbarComponent } from './common/app-navbar/app-navbar.component';
// pages
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SplashComponent } from './pages/splash/splash.component';
import { DashComponent } from './pages/dash/dash.component';
import { HomeComponent } from './pages/dash/home/home.component';
import { UsersComponent } from './pages/dash/users/users.component';
import { FinishSignUpComponent } from './pages/finish-sign-up/finish-sign-up.component';
import { UserComponent } from './pages/dash/user/user.component';
import { CarpetaComponent } from './pages/dash/carpeta/carpeta.component';
import { ProyectoComponent } from './pages/dash/proyecto/proyecto.component';
import { RedirectPqrComponent } from './pages/redirect-pqr/redirect-pqr.component';


@NgModule({
    declarations: [
        AppComponent,
        AppNavbarComponent,
        LoginComponent,
        NotFoundComponent,
        SplashComponent,
        DashComponent,
        HomeComponent,
        UsersComponent,
        FinishSignUpComponent,
        UserComponent,
        CarpetaComponent,
        ProyectoComponent,
        RedirectPqrComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireStorageModule,
        FormsModule,
        Ng4LoadingSpinnerModule.forRoot(),
        NgbModule.forRoot(),
        NgxQRCodeModule,
        ToastModule.forRoot(),
        routes
    ],
    providers: [
        AuthGuard,
        AuthProvider,
        NotificacionesProvider,
        PlanesProvider,
        User,
        Utils
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts